module.exports = __webpack_public_path__ + "static/media/bg.232706eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/bg.png
// module id = 1261
// module chunks = 0